// Dependencies
import { html, render } from 'lit-html';
import { instance } from './home-bricks';

/**
 * Empty object to contain elements
 */
const filter = {};

/**
 * WP REST API constants
 * API_URL - Site URL from WordPress Localize Script function
 * API_ROUTE - Custom endpoint
 */
const API_URL = site.SITE_URL;
const API_ROUTE = 'wp-json/sjw/v1/case_study';

/**
 * Filter Posts
 * @param {string} attr The attrbute to use
 */
export default function filterPosts(attr) {
  // Stop if nothing is passed
  if (!attr) return false;

  // Get elements with matching attribute
  const els = document.querySelectorAll(`[${attr}]`);

  // Stop if elements are not in DOM
  if (!els || !els.length) return false;

  // For each element, add to object with attribute value as property key
  els.forEach(el => {
    // If element has href attribute
    if (el.hasAttribute('href')) {
      // Short circuit check if filters proeprty (Array) exists and create it if not
      !('filters' in filter) && (filter.filters = [])
      // Add element to filters property (Array)
      filter.filters.push(el);

      // Add element to object
    } else {
      filter[el.getAttribute(attr)] = el;
    }
  });

  // Trigger function
  listeners();
}

/**
 * Show Filter Nav
 * @param {object} event Click event
 */
function showFilterNav(event) {
  // Add class to element that triggered Event (Filter Trigger)
  event.currentTarget.classList.add('is-active');

  // Add class to Filter Nav
  filter.nav.classList.add('is-active');
}

/**
 * Hide Filter Nav
 * This function can be triggered by either:
 * - Filter Close Button
 * - Filter Nav Item
 */
function hideFilterNav() {
  // Remove class from eventListener
  filter.trigger.classList.remove('is-active');

  // Remove class from Nav
  filter.nav.classList.remove('is-active');
}

/**
 * Get ID of clicked Category
 * @param {object} event Event object usd to get data attribute from target
 */
function getCategoryId(event) {
  // Loop over filters array
  filter.filters.forEach(item => {
    // If item has active class, remove it
    if (item.classList.contains('is-active')) item.classList.remove('is-active');
  });

  // Add active class to event target
  event.target.classList.add('is-active');

  // Get data attribute value.
  const categoryId = event.target.getAttribute('data-category');

  // Return ID
  return categoryId;
}

/**
 * Template for filtered Posts built using lit-html
 * Parameters have been destructured
 *
 * @param {string} link Post permalink
 * @param {Object} case_study_homepage_image Homepage image details
 * @param {string} case_study_homepage_image_z_index CSS class to determine z-index of Post
 */
function postTemplate({ link, acf: { case_study_homepage_image, case_study_homepage_image_z_index } }) {
  return html`
    <div class="home-grid__item ${case_study_homepage_image_z_index}">
      <a href="${link}">
        <img
          width="${case_study_homepage_image.width}"
          height="${case_study_homepage_image.height}"
          src="${case_study_homepage_image.url}"
          class="attachment-full size-full"
          alt="${case_study_homepage_image.alt}"
          srcset="
            ${case_study_homepage_image.sizes.large} ${case_study_homepage_image.sizes['large-width']}w,
            ${case_study_homepage_image.sizes.medium} ${case_study_homepage_image.sizes['medium-width']}w"
            sizes="(max-width: ${case_study_homepage_image.sizes['medium-width']}px) 100vw, ${case_study_homepage_image.sizes['large-width']}px">
      </a>
    </div>
  `;
}

/**
 * Get Posts from REST API matching Category
 * @param {string} id Category ID to pass to endpoint to filter posts
 */
function getCategoryPosts(id) {
  // Add class to target
  filter.target.classList.add('is-loading');

  // New AJAX request.
  const request = new XMLHttpRequest();

  // Request type
  request.open('GET', `${API_URL}/${API_ROUTE}?categories=${id}`, true);

  // Handle success
  request.onload = function() {
    // If successful response.
    if (this.status >= 200 && this.status < 400) {

      // Parse response and store it.
      const response = JSON.parse(this.response);

      // Loop over response and create HTML for each item
      const posts = response.map(item => postTemplate(item));

      // Render new HTML
      render(posts, filter.target);

      // Pack Bricks.js
      instance.pack();
      // Update Bricks.js
      instance.update();

      // Remove class from target.
      filter.target.classList.remove('is-loading');

    } else {
      // Console error
      console.error(`There was a problem getting posts from the REST API - Status code: ${this.status}`);

      // Render error
      render(
        html`<div>
          <h1 class="size3">There was a problem filtering posts. <br>Please refresh the page and try again.</h1>
        </div>`,
        filter.target
      );

      // Remove class from target.
      filter.target.classList.remove('is-loading');

      return;
    }
  };

  // Handle error
  request.onerror = function() {
    console.error('Could not connect to endpoint.');
  };

  // Send request.
  request.send();
}

/**
 * Event listeners
 */
function listeners() {
  /**
   * Open filter button
   */
  filter.trigger.addEventListener('click', e => showFilterNav(e));

  /**
   * Close filter button
   */
  filter.close.addEventListener('click', hideFilterNav);

  /**
   * Filter Posts by category
   * Get category ID of clicked anchor link
   * Pass it to AJAX request to return data from WP REST API
   */
  filter.nav.addEventListener('click', (e) => {
    // If target doesn't have data attribute, stop.
    if (!e.target.hasAttribute('data-category')) return false;

    // Prevent default action.
    event.preventDefault();

    // Store ID in variable.
    const id = getCategoryId(e);

    // Get posts by ID.
    getCategoryPosts(id);

    // Hide Filter Nav
    hideFilterNav();
  });
}
